/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentReactionsDtoSchema = z.object({
  fire: z.optional(z.int()),
  heart: z.optional(z.int()),
  clap: z.optional(z.int()),
  myFire: z.optional(z.boolean()),
  myHeart: z.optional(z.boolean()),
  myClap: z.optional(z.boolean()),
});
